import React from 'react';
import { format } from 'date-fns';
import styles from '../css/vdr.module.css';

const formatVersionDate = value => {
    if (!value) return '';
    try {
        return format(new Date(value), 'dd MMM yyyy');
    } catch {
        return '';
    }
};

const VersionHistoryPanel = ({ versions = [], onOpen, onDownload, onBack }) => {
    return (
        <div>
            <div className={styles.versionHistoryBack}>
                <button type="button" className={styles.versionHistoryBackBtn} onClick={onBack}>
                    ← Back
                </button>
                <span className={styles.versionHistoryBackTitle}>Version history</span>
            </div>
            {versions.map(version => (
                <div
                    key={version.id || version.version}
                    className={`${styles.versionHistoryRow} ${version.current ? '' : styles.versionHistoryRowPast}`}
                >
                    <div>
                        <div className={styles.versionTitleRow}>
                            <span className={styles.versionHistoryTitle}>Version {version.version}</span>
                            {version.current ? <span className={styles.currentBadge}>Current</span> : null}
                        </div>
                        <div className={styles.versionHistoryMeta}>
                            {[formatVersionDate(version.created), version.uploaded_by_name].filter(Boolean).join(' · ')}
                        </div>
                    </div>
                    <div className={styles.versionActions}>
                        <button type="button" className={`${styles.textLink} ${styles.fileDrawerLink}`} onClick={() => onOpen?.(version)}>
                            Open
                        </button>
                        <button type="button" className={styles.versionDownload} onClick={() => onDownload?.(version)}>
                            Download
                        </button>
                    </div>
                </div>
            ))}
            {versions.length === 0 ? <p className={styles.versionHistoryEmpty}>No versions</p> : null}
        </div>
    );
};

export default VersionHistoryPanel;
